import { IForm } from '@hooks/useForm';
import { ILoading } from '@hooks/useLoading';
import { useModalWindow } from '@hooks/useModalWindow';
import { IStepper } from '@hooks/useStepper';
import { IValueState } from '@hooks/useValueState';
import { IComboContratoOperadora } from '@model/ContratoOperadora';
import ILinha from '@model/Linha';
import { IValidarNumeroResponse } from '@services/ContratoClienteService';
import React from 'react';
import { PageBox } from '../PageBox';
import { LinhaCancelarModal } from './LinhaCancelarModal';
import { LinhaCommand } from './LinhaCommand';
import { LinhaFormulario } from './LinhaFormulario';
import { LinhaSearch } from './LinhaSearch';

export type HomeContratoLinhaProps = {
    stepper: IStepper
    form: IForm<Partial<ILinha>>
    linhaValueState: IValueState<IValidarNumeroResponse>
    loading: ILoading
    contratoOperadoraCombo: IComboContratoOperadora
}

export function HomeContratoLinha ({ 
    stepper,
    form, 
    linhaValueState,
    loading,
    contratoOperadoraCombo 
}: HomeContratoLinhaProps) {
    
    const modal = useModalWindow();

    const telefoneFieldRef = React.useRef<HTMLInputElement>();

    const setTelefoneFieldFocus = React.useCallback(() => {
        setTimeout(() => {
            telefoneFieldRef.current?.focus();
        }, 300)
    }, []);

    const handleCancel = React.useCallback(() => {
        setTelefoneFieldFocus();
    }, [setTelefoneFieldFocus]);

    const handleContratoCancelado = React.useCallback((linha: ILinha) => {
        linhaValueState.set({
            contratoCliente: null,
            linha
        });

        setTelefoneFieldFocus();

    }, [linhaValueState, setTelefoneFieldFocus]);

    const handleModalClosed = React.useCallback(() => {
        linhaValueState.set(undefined);
        setTelefoneFieldFocus();
    }, [linhaValueState, setTelefoneFieldFocus]);

    const searched = linhaValueState.value !== undefined && linhaValueState.value?.linha !== null;
    const linhaFound = !!linhaValueState.value?.linha;

    return (
        <React.Fragment>
            <LinhaSearch 
                linhaValueState={linhaValueState}
                loading={loading}
                form={form}
                telefoneFieldRef={telefoneFieldRef}
                modal={modal}
            />

            {
                searched && !linhaFound && (
                    <PageBox>
                        <LinhaFormulario 
                            form={form}
                            contratoOperadoraCombo={contratoOperadoraCombo}
                        />
                    </PageBox>
                )
            }

            <LinhaCommand
                form={form}
                linhaValueState={linhaValueState}
                stepper={stepper}
                onCancel={handleCancel}
            />

            {
                !!linhaValueState.value?.contratoCliente && (
                    <LinhaCancelarModal 
                        contratoCliente={linhaValueState.value.contratoCliente}
                        modal={modal}
                        onContratoCancelado={handleContratoCancelado}
                        onModalClosed={handleModalClosed}
                    />
                )
            }
        </React.Fragment>
    );
}